<template>
  <el-switch v-model="value"
    active-text="开关"
    inactive-text="Switch"/>
</template>

<script>
export default {
    name : 'TicketFormSwitch',

    props : ['value', 'item']
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketFormSwitch.vue